import { MouseEventHandler } from "react"
import { navigate } from "gatsby"

export const getNavigateOnClickHandler = (
  href: string
): MouseEventHandler<HTMLButtonElement> => (event): void => {
  event.preventDefault()
  navigate(href)
}
